import { render, staticRenderFns } from "./table-pagination.vue?vue&type=template&id=532b3a69&"
import script from "./table-pagination.vue?vue&type=script&lang=js&"
export * from "./table-pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports